import api from 'utils/api'
import Route from 'Services/Route'
import { toastrErrors } from 'utils/error_utils'

export function index(state, organizationId) {
  const url = Route.api.organization.teams.index({ organizationId })
  const req = api(state).get(url)

  return req.then((res) => {
    const { data: { teams } } = res
    return teams
  }).catch((error) => {
    console.error(error)
    toastrErrors('There was an issue fetching these teams!')
    if (error.body) toastrErrors(error.body)
    return null
  })
}
